// extracted by mini-css-extract-plugin
export default {"giftPointBody":"OwnerCashTerms_giftPointBody__+G7p3","okBtn":"OwnerCashTerms_okBtn__f8TbZ","cashNotes":"OwnerCashTerms_cashNotes__w+qtR"};